import { render, staticRenderFns } from "./carftstatussetting.vue?vue&type=template&id=c540aff6&scoped=true&"
import script from "./carftstatussetting.vue?vue&type=script&lang=js&"
export * from "./carftstatussetting.vue?vue&type=script&lang=js&"
import style0 from "./carftstatussetting.vue?vue&type=style&index=0&id=c540aff6&lang=scss&scoped=true&"
import style1 from "./carftstatussetting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c540aff6",
  null
  
)

export default component.exports